import type { ObservationsBatchEditContentProps } from "./observations-batch-edit-content.type";

import BatchTransition from "@/modules/batch-transition";
import ObservationsBatchEditSeverity from "@/modules/observations/observations-batch-edit-severity";
import SidePanelFormFooter from "@/modules/side-panel-form-footer";

const ObservationsBatchEditContent = ({
  property,
  observations,
}: ObservationsBatchEditContentProps) => {
  if (!property) {
    // default footer, with "cancel" button
    return <SidePanelFormFooter hideSubmit />;
  }

  if (property === "state") {
    return <BatchTransition type="observation" items={observations} />;
  }

  if (property === "severity") {
    return <ObservationsBatchEditSeverity observations={observations} />;
  }

  return null;
};

export default ObservationsBatchEditContent;
